module.exports = __webpack_public_path__ + "static/media/whatsapp.1630232f.svg";